import React, { useState } from 'react';
import useTransferPage from './useTransferPage';
import { accordionBox, customIconBtn, sign, signBox, tab, tabs } from './TransferPage.sx';
import {
  Tabs,
  Tab,
  Box,
  Button,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
  Slide,
  Typography,
} from '@mui/material';
import PageHeader from 'app/components/PageHeader';
import AccordionCustom from 'app/components/AccordionCustom';
import GeneralDetails from 'app/components/AccordionCustom/GeneralDetails';
import PaymentDetails from 'app/components/AccordionCustom/PaymentDetails';
import AttachDetails from 'app/components/AccordionCustom/AttachDetails';
import BookmarkIcon from 'app/components/Icons/BookmarkIcon';
import SaveTemplate from 'app/components/SaveTemplate';
import AsanConfirmation from 'app/components/AsanConfirmation';
import SuccessModal from 'app/components/SuccessModal';
import NavArrow from 'app/components/Icons/NavArrow';
import TransferConfirmPage from './TransferConfirmPage';
import AlertModal from 'app/pages/TransferPage/AlertModal';
import logger from 'app/utils/logger';
import CustomSnackbar from 'app/components/CustomSnackbar';
import WarningIcon from 'app/components/Icons/WarningIcon';
import LeaveModal from 'app/pages/TransferPage/LeaveModal';
import BackIcon from 'app/components/Icons/BackIcon';
import SaveIcon from 'app/components/Icons/SaveIcon';
import { black1, green, grey, grey13Opacity38, grey9, red2, white } from 'app/components/ThemeProvider/colors';
import BinIcon from 'app/components/Icons/BinIcon';
import DeleteTemplateModal from 'app/pages/TemplatesPage/TemplateModals/DeleteTemplateModal';
import { useDeleteTemplate } from 'app/utils/services/templateService';

interface CustomNavButtonsProps {
  disabled?: boolean;
  direction?: string;
  slotProps?: any;
}

const CustomNavButtons = (props: CustomNavButtonsProps) => {
  const { disabled, direction, slotProps, ...rest } = props;

  return (
    <IconButton {...rest} sx={customIconBtn(disabled, direction)}>
      <NavArrow color={disabled ? 'warning' : 'primary'} />
    </IconButton>
  );
};

const TransferPage = () => {
  const {
    valuePageId,
    confirm,
    // asanConfirmation,
    // setAsanConfirmation,
    // setSuccesModal,
    // successModal,
    selectedOptions,
    saveTemplate,
    setSaveTemplate,
    handleChange,
    onChange,
    dataGetTransfer,
    isLoadingGetDataTransfer,
    fromAccount,
    selectedFromAccount,
    onChangeFromAccount,
    toAccount,
    selectedToAccount,
    onChangeToAccount,
    control,
    register,
    disabledToAccount,
    handleSubmit,
    submitForm,
    errors,
    openAlertModal,
    setOpenAlertModal,
    handleSubmitInBank,
    registerInBank,
    controlInBank,
    errorsInBank,
    handleOnChangeInBankToAccount,
    dataGetBeneficiar,
    onDropInBank,
    fileInBank,
    setFileInBank,
    handleSubmitLocalTransfer,
    controlLocalTransfer,
    errorsLocalTransfer,
    registerLocalTransfer,
    onDropLocalTransfer,
    fileLocalTransfer,
    commission,
    handleChangeCommissionLocalTransfer,
    errorFileInBank,
    getValuesInBank,
    countryOptions,
    customerType,
    handleChangeCustomerType,
    handleChangeLocalTransferBeneficiarCode,
    handleDeleteInBankFile,
    openBankCodeLocalTransferDialog,
    setOpenBankCodeLocalTransferDialog,
    dataGetBeneficiarDataLocalTransfer,
    bankCodeData,
    getBeneficiarDataLocalTransferMutation,
    handleClickLocalTransferBankCode,
    setIsSearchLocalTransfer,
    handleSwitchSelfPayment,
    selfPayment,
    submitFormInBank,
    isLoadingGetBeneficiar,
    isLoadingFileUpload,
    handleChangeIpsValueInput,
    ipsValueInput,
    dataGetIpsData,
    handleSearchIps,
    handleSubmitEdv,
    errorsEdv,
    setValueEdv,
    getValuesEdv,
    controlEdv,
    registerEdv,
    dataSendTransferType,
    registerBudget,
    getValuesBudget,
    handleSubmitBudget,
    setValueBudget,
    errorsBudget,
    controlBudget,
    budgetLevelCodes,
    handleChangeSelectedBudgetValue,
    selectedBudgetLevelCodes,
    openBudgetOrgDialog,
    setOpenBudgetOrgDialog,
    getClassificationMutation,
    handleClickOrgCode,
    orgCodeChange,
    errorsConversion,
    registerConversion,
    controlConversion,
    fromAccountConversion,
    toAccountConversion,
    handleChangeFromConversion,
    handleChangeToConversion,
    selectedToAccountConversion,
    selectedCommissionConversion,
    selectedFromAccountConversion,
    handleChangeCommissionConversion,
    checkIndividualConversion,
    handleSwitchIndividualConversion,
    rates,
    selectedRates,
    handleSelectRates,
    fromAmountConversion,
    handleChangeFromAmountConversion,
    toAmountConversion,
    handleChangeToAmountConversion,
    handleSwitchCurrencyConversion,
    isLoadingSendTransferType,
    isLoadingSendTransferTypeFromGetData,
    controlForeign,
    registerForeign,
    errorsForeign,
    countries,
    selectedCountries,
    handleChangeCountry,
    mediatorBank,
    handleSwitchMediatorBank,
    avans,
    handleSwitchAvans,
    fileForeign,
    onDropForeignTransfer,
    getValuesForeign,
    getValuesLocalTransfer,
    openMediatorSwiftBicCode,
    setOpenSwiftBicCode,
    openSwiftBicCode,
    setOpenMediatorSwiftBicCode,
    getSwiftCodeMutation,
    handleClickSwiftCode,
    handleClickMediatorSwiftCode,
    submitFormForeign,
    handleSubmitForeign,
    openSnackbar,
    setOpenSnackBar,
    dataAcc2acc,
    isLoadingAcc2acc,
    submitFormEdv,
    submitFormBudget,
    bankCodeValueLocal,
    handleSearchMediatorSwiftCode,
    handleSearchSwiftCode,
    setSwiftMediatorCodeForeign,
    setSwiftCodeForeign,
    handleChangeBudgetClassCode,
    classCodeBudget,
    dataGetOrganization,
    dataGetClassification,
    handleSubmitConversion,
    submitFormConversion,
    handleSwitchTaxEnabled,
    taxEnabledLocal,
    submitFormLocalTransfer,
    sendTransferTypeMutation,
    checkLeave,
    setCheckLeave,
    handleLeavePage,
    pageName,
    dataSwiftCode,
    setSelectedFromAccountTrigger,
    getValues,
    ibanField,
    handleChangeAmount,
    amountValue,
    handleChangeInvoiceNo,
    invoiceValue,
    budgetIban,
    valueTextArea,
    handleChangeTextArea,
    commissionOption,
    individualRates,
    handleChangeIndividualRate,
    voenEdv,
    beneficiarNameEdv,
    handleChangeVoenEdv,
    handleChangeBeneficiarNameEdv,
    innForeign,
    kppForeign,
    beneficiarNameForeign,
    beneficiarAddressForeign,
    handleChangeInnForeign,
    handleChangeKppForeign,
    handleChangeBeneficiarNameForeign,
    handleChangeBeneficiarAddressForeign,
    voenLocal,
    beneficiarIbanLocal,
    beneficiarNameLocal,
    handleChangeBeneficiarIbanLocal,
    handleChangeVoenLocal,
    handleChangeBeneficiarNameLocal,
    contractNumberRequiredInBank,
    handleSaveTemplate,
    handleChangeTemplateName,
    pathUrl,
    navigate,
    dataCreateTemplate,
    saveTemplateSuccess,
    setSaveTemplateSuccess,
    handleEditTemplate,
    templateData,
    templateName,
    showTemplateBtn,
    setTemplateName,
    errorSaveTemplate,
    setErrorSaveTemplate,
    formId,
  } = useTransferPage();

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { isLoadingDeleteTemplate, deleteTemplateMutation, dataDeleteTemplate } = useDeleteTemplate(
    pathUrl.endsWith('edit-template')
  );

  if (isLoadingGetDataTransfer) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else if (isLoadingAcc2acc) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else if (confirm) {
    return (
      <TransferConfirmPage
        data={dataAcc2acc.confirm_page_data}
        businessKey={dataAcc2acc?.business_key}
        saveTemplate={saveTemplate}
        setSaveTemplate={setSaveTemplate}
        handleSaveTemplate={handleSaveTemplate}
        handleChangeTemplateName={handleChangeTemplateName}
        saveTemplateSuccess={saveTemplateSuccess}
        setSaveTemplateSuccess={setSaveTemplateSuccess}
        changeName={setTemplateName}
        templateName={templateName}
        pathUrl={pathUrl}
        dataCreateTemplate={dataCreateTemplate}
        error={errorSaveTemplate}
        setError={setErrorSaveTemplate}
      />
    );
  } else if (isLoadingSendTransferType) {
    return (
      <Box>
        <PageHeader
          pageName={
            pathUrl === 'transfer-page' && (templateData === null || templateData === undefined)
              ? 'Köçürmə və ödənişlər'
              : pathUrl.endsWith('edit-template')
              ? templateData.title
              : pathUrl === 'transfer-page' && (templateData !== null || templateData !== undefined)
              ? templateData.title
              : pathUrl.endsWith('new-template') && 'Yeni şablonun yaradılması'
          }
          subtitle={
            templateData !== undefined && valuePageId === 'payment_acc2acc'
              ? 'Öz hesablarım arasında'
              : templateData !== undefined && valuePageId === 'payment_interbank'
              ? 'Bankdaxili'
              : templateData !== undefined && valuePageId === 'payment_local_transfer'
              ? 'Ölkədaxili'
              : templateData !== undefined && valuePageId === 'payment_foreign_transfer'
              ? 'Xarici valyutada'
              : templateData !== undefined && valuePageId === 'payment_edv'
              ? 'Ədv ödənişi'
              : templateData !== undefined && valuePageId === 'payment_budget'
              ? 'Büdcə ödənişi'
              : templateData !== undefined && valuePageId === 'payment_conversion' && 'Konvertasiya'
          }
          // back={!(pathUrl === 'transfer-page' && (templateData === null || templateData === undefined))}
          showBtnBox={pathUrl === 'transfer-page' && true}
          template={false}
        />
        {pathUrl === 'transfer-page' && (templateData === null || templateData === undefined) && (
          <Tabs
            value={valuePageId}
            onChange={handleChange}
            sx={tabs}
            variant="scrollable"
            ScrollButtonComponent={(props: any) => {
              return <CustomNavButtons {...props} disabled={props.disabled} direction={props.direction} />;
            }}
          >
            {dataGetTransfer?.transfer_types.map((tabItem: any) => (
              <Tab key={tabItem.name} sx={tab} label={tabItem.title} value={tabItem.name} />
            ))}
          </Tabs>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            height: 'calc(100vh - 340px)',
          }}
        >
          <CircularProgress />
        </Box>
      </Box>
    );
  } else if (isLoadingSendTransferTypeFromGetData) {
    return (
      <Box>
        <PageHeader
          pageName={
            pathUrl === 'transfer-page' && (templateData === null || templateData === undefined)
              ? 'Köçürmə və ödənişlər'
              : pathUrl.endsWith('edit-template')
              ? templateData.title
              : pathUrl === 'transfer-page' && (templateData !== null || templateData !== undefined)
              ? templateData.title
              : pathUrl.endsWith('new-template') && 'Yeni şablonun yaradılması'
          }
          subtitle={
            templateData !== undefined && valuePageId === 'payment_acc2acc'
              ? 'Öz hesablarım arasında'
              : templateData !== undefined && valuePageId === 'payment_interbank'
              ? 'Bankdaxili'
              : templateData !== undefined && valuePageId === 'payment_local_transfer'
              ? 'Ölkədaxili'
              : templateData !== undefined && valuePageId === 'payment_foreign_transfer'
              ? 'Xarici valyutada'
              : templateData !== undefined && valuePageId === 'payment_edv'
              ? 'Ədv ödənişi'
              : templateData !== undefined && valuePageId === 'payment_budget'
              ? 'Büdcə ödənişi'
              : templateData !== undefined && valuePageId === 'payment_conversion' && 'Konvertasiya'
          }
          // back={!(pathUrl === 'transfer-page' && (templateData === null || templateData === undefined))}
          showBtnBox={true}
          template={false}
        />
        {pathUrl === 'transfer-page' && (templateData === null || templateData === undefined) && (
          <Tabs
            value={valuePageId}
            onChange={handleChange}
            sx={tabs}
            variant="scrollable"
            ScrollButtonComponent={(props: any) => {
              return <CustomNavButtons {...props} disabled={props.disabled} direction={props.direction} />;
            }}
          >
            {dataGetTransfer?.transfer_types.map((tabItem: any) => (
              <Tab key={tabItem.name} sx={tab} label={tabItem.title} value={tabItem.name} />
            ))}
          </Tabs>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            height: '100%',
          }}
        >
          <CircularProgress />
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ position: 'relative' }}>
        <PageHeader
          pageName={
            pathUrl === 'transfer-page' && (templateData === null || templateData === undefined)
              ? 'Köçürmə və ödənişlər'
              : pathUrl.endsWith('edit-template')
              ? templateData.title
              : pathUrl === 'transfer-page' && (templateData !== null || templateData !== undefined)
              ? templateData.title
              : pathUrl.endsWith('new-template') && 'Yeni şablonun yaradılması'
          }
          subtitle={
            templateData !== undefined && valuePageId === 'payment_acc2acc'
              ? 'Öz hesablarım arasında'
              : templateData !== undefined && valuePageId === 'payment_interbank'
              ? 'Bankdaxili'
              : templateData !== undefined && valuePageId === 'payment_local_transfer'
              ? 'Ölkədaxili'
              : templateData !== undefined && valuePageId === 'payment_foreign_transfer'
              ? 'Xarici valyutada'
              : templateData !== undefined && valuePageId === 'payment_edv'
              ? 'Ədv ödənişi'
              : templateData !== undefined && valuePageId === 'payment_budget'
              ? 'Büdcə ödənişi'
              : templateData !== undefined && valuePageId === 'payment_conversion' && 'Konvertasiya'
          }
          // back={!(pathUrl === 'transfer-page' && (templateData === null || templateData === undefined))}
          showBtnBox={true}
          template={false}
        />
        {pathUrl === 'transfer-page' && (templateData === null || templateData === undefined) && (
          <Tabs
            value={valuePageId}
            onChange={handleChange}
            sx={tabs}
            variant="scrollable"
            ScrollButtonComponent={(props: any) => {
              return <CustomNavButtons {...props} disabled={props.disabled} direction={props.direction} />;
            }}
          >
            {dataGetTransfer?.transfer_types.map((tabItem: any) => (
              <Tab key={tabItem.name} sx={tab} label={tabItem.title} value={tabItem.name} />
            ))}
          </Tabs>
        )}

        <form
          onSubmit={
            valuePageId === 'payment_acc2acc'
              ? handleSubmit(submitForm)
              : valuePageId === 'payment_interbank'
              ? handleSubmitInBank(submitFormInBank)
              : valuePageId === 'payment_local_transfer'
              ? handleSubmitLocalTransfer(submitFormLocalTransfer)
              : valuePageId === 'payment_foreign_transfer'
              ? handleSubmitForeign(submitFormForeign)
              : valuePageId === 'payment_edv'
              ? handleSubmitEdv(submitFormEdv)
              : valuePageId === 'payment_budget'
              ? handleSubmitBudget(submitFormBudget)
              : valuePageId === 'payment_conversion' && handleSubmitConversion(submitFormConversion)
          }
        >
          <Box sx={accordionBox}>
            <AccordionCustom
              pageName={'transfer'}
              headerText={'Ödəniş detalları'}
              detailsAccordion={
                <PaymentDetails
                  type={valuePageId}
                  value={selectedOptions}
                  accountOptions={fromAccount}
                  selectedFromAccount={selectedFromAccount}
                  onChangeFromAccount={onChangeFromAccount}
                  onChangeCommission={handleChangeCommissionLocalTransfer}
                  onChangeAmount={handleChangeAmount}
                  amount={amountValue}
                  selectedCommission={commission}
                  commissionOption={commissionOption}
                  fromAccountConversion={fromAccountConversion}
                  toAccountConversion={toAccountConversion}
                  handleChangeFromConversion={handleChangeFromConversion}
                  handleChangeToConversion={handleChangeToConversion}
                  selectedFromAccountConversion={selectedFromAccountConversion}
                  selectedToAccountConversion={selectedToAccountConversion}
                  commissionConversion={selectedCommissionConversion}
                  handleChangeCommissionConversion={handleChangeCommissionConversion}
                  checkIndividualConversion={checkIndividualConversion}
                  handleSwitchIndividualConversion={handleSwitchIndividualConversion}
                  rates={rates}
                  selectedRates={selectedRates}
                  handleSelectRates={handleSelectRates}
                  fromAmountConversion={fromAmountConversion}
                  toAmountConversion={toAmountConversion}
                  handleChangeFromAmountConversion={handleChangeFromAmountConversion}
                  handleChangeToAmountConversion={handleChangeToAmountConversion}
                  handleSwitchCurrencyConversion={handleSwitchCurrencyConversion}
                  control={
                    valuePageId === 'payment_acc2acc'
                      ? control
                      : valuePageId === 'payment_interbank'
                      ? controlInBank
                      : valuePageId === 'payment_local_transfer'
                      ? controlLocalTransfer
                      : valuePageId === 'payment_edv'
                      ? controlEdv
                      : valuePageId === 'payment_budget'
                      ? controlBudget
                      : valuePageId === 'payment_conversion'
                      ? controlConversion
                      : valuePageId === 'payment_foreign_transfer' && controlForeign
                  }
                  register={
                    valuePageId === 'payment_acc2acc'
                      ? register
                      : valuePageId === 'payment_interbank'
                      ? registerInBank
                      : valuePageId === 'payment_local_transfer'
                      ? registerLocalTransfer
                      : valuePageId === 'payment_edv'
                      ? registerEdv
                      : valuePageId === 'payment_budget'
                      ? registerBudget
                      : valuePageId === 'payment_conversion'
                      ? registerConversion
                      : valuePageId === 'payment_foreign_transfer' && registerForeign
                  }
                  errors={
                    valuePageId === 'payment_acc2acc'
                      ? errors
                      : valuePageId === 'payment_interbank'
                      ? errorsInBank
                      : valuePageId === 'payment_local_transfer'
                      ? errorsLocalTransfer
                      : valuePageId === 'payment_edv'
                      ? errorsEdv
                      : valuePageId === 'payment_budget'
                      ? errorsBudget
                      : valuePageId === 'payment_conversion'
                      ? errorsConversion
                      : valuePageId === 'payment_foreign_transfer' && errorsForeign
                  }
                  dataForm={dataAcc2acc}
                  individualRates={individualRates}
                  handleChangeIndividualRate={handleChangeIndividualRate}
                />
              }
            />
            {valuePageId !== 'payment_conversion' && (
              <AccordionCustom
                pageName={'transfer'}
                headerText={'Ümumi detallar'}
                detailsAccordion={
                  <GeneralDetails
                    type={valuePageId}
                    countryDetails={countryOptions}
                    value={selectedOptions}
                    selectedFromAccount={selectedFromAccount}
                    change={onChange}
                    accountOptions={toAccount}
                    handleChangeCustomerType={handleChangeCustomerType}
                    customerType={customerType}
                    selectedToAccount={selectedToAccount}
                    beneficiarData={dataGetBeneficiar}
                    onChangeToAccount={
                      valuePageId === 'payment_acc2acc'
                        ? onChangeToAccount
                        : valuePageId === 'payment_interbank'
                        ? handleOnChangeInBankToAccount
                        : valuePageId === 'payment_local_transfer' && handleChangeLocalTransferBeneficiarCode
                    }
                    disabled={disabledToAccount}
                    control={
                      valuePageId === 'payment_acc2acc'
                        ? control
                        : valuePageId === 'payment_interbank'
                        ? controlInBank
                        : valuePageId === 'payment_local_transfer'
                        ? controlLocalTransfer
                        : valuePageId === 'payment_edv'
                        ? controlEdv
                        : valuePageId === 'payment_budget'
                        ? controlBudget
                        : valuePageId === 'payment_foreign_transfer' && controlForeign
                    }
                    register={
                      valuePageId === 'payment_acc2acc'
                        ? register
                        : valuePageId === 'payment_interbank'
                        ? registerInBank
                        : valuePageId === 'payment_local_transfer'
                        ? registerLocalTransfer
                        : valuePageId === 'payment_edv'
                        ? registerEdv
                        : valuePageId === 'payment_budget'
                        ? registerBudget
                        : valuePageId === 'payment_foreign_transfer' && registerForeign
                    }
                    errors={
                      valuePageId === 'payment_acc2acc'
                        ? errors
                        : valuePageId === 'payment_interbank'
                        ? errorsInBank
                        : valuePageId === 'payment_local_transfer'
                        ? errorsLocalTransfer
                        : valuePageId === 'payment_edv'
                        ? errorsEdv
                        : valuePageId === 'payment_budget'
                        ? errorsBudget
                        : valuePageId === 'payment_foreign_transfer' && errorsForeign
                    }
                    values={valuePageId === 'payment_interbank' && getValuesInBank}
                    bankCodeLocalTransferOpen={openBankCodeLocalTransferDialog}
                    bankCodeLocalTransferSet={setOpenBankCodeLocalTransferDialog}
                    localTransferBankData={bankCodeData}
                    getBankCodeData={getBeneficiarDataLocalTransferMutation}
                    getOrgData={getClassificationMutation}
                    transferData={dataGetTransfer}
                    clickLocalTransferBankCode={handleClickLocalTransferBankCode}
                    setIsSearch={setIsSearchLocalTransfer}
                    switchSelf={handleSwitchSelfPayment}
                    selfPayment={selfPayment}
                    ipsValue={ipsValueInput}
                    handleChangeIps={handleChangeIpsValueInput}
                    dataIps={dataGetIpsData}
                    handleSearchIps={handleSearchIps}
                    edvBudgetData={dataSendTransferType}
                    budgetLevelCodes={budgetLevelCodes}
                    handleChangeSelectedBudgetValue={handleChangeSelectedBudgetValue}
                    selectedBudgetLevelCodes={selectedBudgetLevelCodes}
                    orgOpen={openBudgetOrgDialog}
                    orgClose={setOpenBudgetOrgDialog}
                    clickOrgCode={
                      valuePageId === 'payment_budget'
                        ? handleClickOrgCode
                        : valuePageId === 'payment_local_transfer' && handleClickLocalTransferBankCode
                    }
                    budgetOrgCodeChange={orgCodeChange}
                    countries={countries}
                    selectedCountry={selectedCountries}
                    handleChangeCountry={handleChangeCountry}
                    mediatorBank={mediatorBank}
                    handleSwitchMediatorBank={handleSwitchMediatorBank}
                    openDialogSwiftBic={openSwiftBicCode}
                    setOpenDialogSwiftBic={setOpenSwiftBicCode}
                    openMediatorDialogSwiftBic={openMediatorSwiftBicCode}
                    setOpenMediatorDialogSwiftBic={setOpenMediatorSwiftBicCode}
                    getSwiftCode={getSwiftCodeMutation}
                    handleClickSwiftCode={handleClickSwiftCode}
                    handleClickMediatorSwiftCode={handleClickMediatorSwiftCode}
                    dataForm={dataAcc2acc}
                    bankCodeValueLocal={bankCodeValueLocal}
                    handleSearchSwift={handleSearchSwiftCode}
                    handleSearchMediatorSwift={handleSearchMediatorSwiftCode}
                    setSwiftCodeForeign={setSwiftCodeForeign}
                    setSwiftMediatorCodeForeign={setSwiftMediatorCodeForeign}
                    budgetClassCode={handleChangeBudgetClassCode}
                    classCodeBudget={classCodeBudget}
                    dataOrganization={dataGetOrganization}
                    dataClassification={dataGetClassification}
                    beneficiarDataLocal={dataGetBeneficiarDataLocalTransfer}
                    dataSwiftCode={dataSwiftCode}
                    ibanField={ibanField}
                    budgetIban={budgetIban}
                    voenEdv={voenEdv}
                    beneficiarNameEdv={beneficiarNameEdv}
                    handleChangeVoenEdv={handleChangeVoenEdv}
                    handleChangeBeneficiarNameEdv={handleChangeBeneficiarNameEdv}
                    innForeign={innForeign}
                    kppForeign={kppForeign}
                    beneficiarNameForeign={beneficiarNameForeign}
                    beneficiarAddressForeign={beneficiarAddressForeign}
                    handleChangeInnForeign={handleChangeInnForeign}
                    handleChangeKppForeign={handleChangeKppForeign}
                    handleChangeBeneficiarNameForeign={handleChangeBeneficiarNameForeign}
                    handleChangeBeneficiarAddressForeign={handleChangeBeneficiarAddressForeign}
                    voenLocal={voenLocal}
                    beneficiarIbanLocal={beneficiarIbanLocal}
                    beneficiarNameLocal={beneficiarNameLocal}
                    handleChangeBeneficiarIbanLocal={handleChangeBeneficiarIbanLocal}
                    handleChangeVoenLocal={handleChangeVoenLocal}
                    handleChangeBeneficiarNameLocal={handleChangeBeneficiarNameLocal}
                  />
                }
              />
            )}
            {valuePageId !== 'payment_conversion' && (
              <AccordionCustom
                pageName={'transfer'}
                headerText={'Təyinat və əlavələr'}
                detailsAccordion={
                  <AttachDetails
                    type={valuePageId}
                    value={selectedOptions}
                    handleChangeInvoiceNo={handleChangeInvoiceNo}
                    invoiceValue={invoiceValue}
                    register={
                      valuePageId === 'payment_acc2acc'
                        ? register
                        : valuePageId === 'payment_interbank'
                        ? registerInBank
                        : valuePageId === 'payment_local_transfer'
                        ? registerLocalTransfer
                        : valuePageId === 'payment_edv'
                        ? registerEdv
                        : valuePageId === 'payment_budget'
                        ? registerBudget
                        : valuePageId === 'payment_foreign_transfer' && registerForeign
                    }
                    errors={
                      valuePageId === 'payment_acc2acc'
                        ? errors
                        : valuePageId === 'payment_interbank'
                        ? errorsInBank
                        : valuePageId === 'payment_local_transfer'
                        ? errorsLocalTransfer
                        : valuePageId === 'payment_edv'
                        ? errorsEdv
                        : valuePageId === 'payment_budget'
                        ? errorsBudget
                        : valuePageId === 'payment_foreign_transfer' && errorsForeign
                    }
                    file={
                      // valuePageId === 'payment_interbank'
                      //   ?
                      fileInBank
                      // : valuePageId === 'payment_local_transfer'
                      // ? fileLocalTransfer
                      // : valuePageId === 'payment_foreign_transfer' && fileForeign
                    }
                    onDrop={
                      valuePageId === 'payment_interbank'
                        ? onDropInBank
                        : valuePageId === 'payment_local_transfer'
                        ? onDropLocalTransfer
                        : valuePageId === 'payment_foreign_transfer' && onDropForeignTransfer
                    }
                    deleteFile={handleDeleteInBankFile}
                    errorFileSize={errorFileInBank}
                    values={
                      valuePageId === 'payment_acc2acc'
                        ? getValues
                        : valuePageId === 'payment_interbank'
                        ? getValuesInBank
                        : valuePageId === 'payment_local_transfer'
                        ? getValuesLocalTransfer
                        : valuePageId === 'payment_foreign_transfer' && getValuesForeign
                    }
                    avans={avans}
                    handleSwitchAvans={handleSwitchAvans}
                    dataForm={dataAcc2acc}
                    handleSwitchEdv={handleSwitchTaxEnabled}
                    valueTaxEnabled={taxEnabledLocal}
                    selectedCountry={selectedCountries}
                    valueTextArea={valueTextArea}
                    handleChangeTextArea={handleChangeTextArea}
                    contractNumberRequired={contractNumberRequiredInBank}
                    selectedAccount={selectedFromAccount}
                  />
                }
              />
            )}
          </Box>
          {dataGetBeneficiar?.error !== undefined && dataGetBeneficiar?.error.text.length > 0 && (
            <CustomSnackbar
              open={openSnackbar}
              setOpen={setOpenSnackBar}
              hideDuration={5000}
              type={dataGetBeneficiar?.error.type}
              text={dataGetBeneficiar?.error.text}
            />
          )}
          {dataGetBeneficiarDataLocalTransfer?.error !== undefined &&
            dataGetBeneficiarDataLocalTransfer?.error.text.length > 0 && (
              <CustomSnackbar
                open={openSnackbar}
                setOpen={setOpenSnackBar}
                hideDuration={5000}
                type={dataGetBeneficiarDataLocalTransfer?.error.type}
                text={dataGetBeneficiarDataLocalTransfer?.error.text}
              />
            )}
          {dataAcc2acc?.error !== undefined && dataAcc2acc?.error.text.length > 0 && (
            <CustomSnackbar
              open={openSnackbar}
              setOpen={setOpenSnackBar}
              hideDuration={5000}
              type={dataAcc2acc?.error.type}
              text={dataAcc2acc?.error.text}
            />
          )}
          {dataGetIpsData?.error !== undefined && dataGetIpsData?.error.text.length > 0 && (
            <CustomSnackbar
              open={openSnackbar}
              setOpen={setOpenSnackBar}
              hideDuration={5000}
              type={dataGetIpsData?.error.type}
              text={dataGetIpsData?.error.text}
            />
          )}
          {dataGetOrganization?.error !== undefined && dataGetOrganization?.error.text.length > 0 && (
            <CustomSnackbar
              open={openSnackbar}
              setOpen={setOpenSnackBar}
              hideDuration={5000}
              type={dataGetOrganization?.error.type}
              text={dataGetOrganization?.error.text}
            />
          )}
          {dataSwiftCode?.error !== undefined && dataSwiftCode?.error?.text.length > 0 && (
            <CustomSnackbar
              open={openSnackbar}
              setOpen={setOpenSnackBar}
              hideDuration={5000}
              type={dataSwiftCode?.error.type}
              text={dataSwiftCode?.error.text}
            />
          )}
          {dataGetClassification?.error !== undefined && dataGetClassification?.error?.text.length > 0 && (
            <CustomSnackbar
              open={openSnackbar}
              setOpen={setOpenSnackBar}
              hideDuration={5000}
              type={dataGetClassification?.error.type}
              text={dataGetClassification?.error.text}
            />
          )}
          {checkLeave && (
            <LeaveModal
              open={checkLeave}
              close={setCheckLeave}
              setChangeNameModal={setSaveTemplate}
              handleLeavePage={handleLeavePage}
              pageName={pageName}
              showTemplate={showTemplateBtn}
            />
          )}
          {pathUrl === 'transfer-page' && templateData !== null && templateData !== undefined ? (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '32px' }}>
              <Button color={'secondary'} onClick={() => navigate(-1)}>
                <BackIcon />
                Geri qayıt
              </Button>
              <Box sx={{ display: 'flex', gap: '17px' }}>
                <Button
                  sx={{ ...sign, display: 'flex', gap: '12px', background: green, '&:hover': { background: green } }}
                  color={'secondary'}
                  onClick={() => {
                    if (formId === 'repayment') {
                      setSaveTemplate(true);
                    } else {
                      handleEditTemplate();
                    }
                  }}
                >
                  <SaveIcon />
                  {formId === 'repayment' ? 'Şablon kimi yadda saxla' : 'Dəyişiklikləri yadda saxla'}
                </Button>
                {formId === 'repayment' && saveTemplate ? (
                  <SaveTemplate
                    open={saveTemplate}
                    close={setSaveTemplate}
                    save={handleSaveTemplate}
                    changeName={setTemplateName}
                    templateName={templateName}
                    successModal={saveTemplateSuccess}
                    setSuccessModal={setSaveTemplateSuccess}
                    pathUrl={pathUrl}
                    dataCreateTemplate={dataCreateTemplate}
                    error={errorSaveTemplate}
                    setError={setErrorSaveTemplate}
                  />
                ) : (
                  saveTemplateSuccess && (
                    <SuccessModal
                      open={saveTemplateSuccess}
                      close={setSaveTemplateSuccess}
                      successText={'Şablon uğurla yadda saxlanıldı!'}
                      path={pathUrl}
                      templates={true}
                    />
                  )
                )}
                <Box sx={signBox}>
                  <AlertModal
                    open={openAlertModal}
                    close={setOpenAlertModal}
                    transferMutation={sendTransferTypeMutation}
                    getTransfer={dataGetTransfer}
                  />
                  <Button
                    sx={sign}
                    type={'submit'}
                    disabled={isLoadingFileUpload || isLoadingGetBeneficiar}
                    onClick={() => setSelectedFromAccountTrigger(true)}
                  >
                    Davam et
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : pathUrl === 'transfer-page' ? (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '32px' }}>
              <Button
                sx={{
                  display: 'flex',
                  gap: '12px',
                  color: !showTemplateBtn ? grey : black1,

                  '@media screen and (max-width: 430px)': {
                    fontSize: '14px !important',
                    gap: '8px',
                  },

                  '&.Mui-disabled': {
                    backgroundColor: grey9,
                    color: grey13Opacity38,
                  },
                }}
                color={'secondary'}
                onClick={() => setSaveTemplate(true)}
                disabled={!showTemplateBtn}
              >
                <BookmarkIcon color={!showTemplateBtn ? 'secondary' : 'warning'} />
                Şablon kimi yadda saxla
              </Button>
              {saveTemplate && (
                <SaveTemplate
                  open={saveTemplate}
                  close={setSaveTemplate}
                  save={handleSaveTemplate}
                  changeName={setTemplateName}
                  templateName={templateName}
                  successModal={saveTemplateSuccess}
                  setSuccessModal={setSaveTemplateSuccess}
                  pathUrl={pathUrl}
                  dataCreateTemplate={dataCreateTemplate}
                  error={errorSaveTemplate}
                  setError={setErrorSaveTemplate}
                />
              )}

              <Box sx={signBox}>
                <AlertModal
                  open={openAlertModal}
                  close={setOpenAlertModal}
                  transferMutation={sendTransferTypeMutation}
                  getTransfer={dataGetTransfer}
                />
                <Button
                  sx={sign}
                  type={'submit'}
                  disabled={isLoadingFileUpload || isLoadingGetBeneficiar}
                  onClick={() => setSelectedFromAccountTrigger(true)}
                >
                  Davam et
                </Button>
              </Box>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '32px' }}>
              <Button color={'secondary'} onClick={() => navigate(-1)}>
                <BackIcon />
                Geri qayıt
              </Button>

              {pathUrl.endsWith('edit-template') ? (
                <Box sx={{ display: 'flex', gap: '16px' }}>
                  <Button
                    sx={{
                      background: red2,
                      color: white,
                      display: 'flex',
                      alignItems: 'center',
                      '&:hover': { background: red2 },
                    }}
                    onClick={() => setOpenDeleteModal(true)}
                  >
                    <BinIcon color={'info'} />
                    Sil
                  </Button>
                  <Button
                    sx={{ ...sign, display: 'flex', gap: '12px', background: green, '&:hover': { background: green } }}
                    color={'secondary'}
                    onClick={handleEditTemplate}
                  >
                    <SaveIcon />
                    Dəyişiklikləri yadda saxla
                  </Button>
                  <DeleteTemplateModal
                    open={openDeleteModal}
                    close={setOpenDeleteModal}
                    id={templateData.templateId}
                    deleteTemplate={deleteTemplateMutation}
                    isEdit={true}
                    data={dataDeleteTemplate}
                  />
                  {saveTemplateSuccess && (
                    <SuccessModal
                      open={saveTemplateSuccess}
                      close={setSaveTemplateSuccess}
                      successText={'Şablon uğurla yadda saxlanıldı!'}
                      path={pathUrl}
                      templates={true}
                    />
                  )}
                </Box>
              ) : (
                <Button
                  sx={{ ...sign, display: 'flex', gap: '12px' }}
                  color={'secondary'}
                  onClick={() => setSaveTemplate(true)}
                  disabled={!showTemplateBtn}
                >
                  <BookmarkIcon color={!showTemplateBtn ? 'secondary' : 'success'} />
                  Şablon kimi yadda saxla
                </Button>
              )}

              {saveTemplate && (
                <SaveTemplate
                  open={saveTemplate}
                  close={setSaveTemplate}
                  save={handleSaveTemplate}
                  changeName={setTemplateName}
                  templateName={templateName}
                  successModal={saveTemplateSuccess}
                  setSuccessModal={setSaveTemplateSuccess}
                  pathUrl={pathUrl}
                  dataCreateTemplate={dataCreateTemplate}
                  error={errorSaveTemplate}
                  setError={setErrorSaveTemplate}
                />
              )}
            </Box>
          )}
        </form>
      </Box>
    );
  }
};

export default TransferPage;
